import React from "react";
import { useRecordContext } from "react-admin";

type Props = {
  sortable?: boolean;
  source?: string;
};

export const ExistsSpecialConditionsField: React.FC<Props> = () => {
  const record = useRecordContext();

  if (!record) {
    return null;
  }

  if (record.special_condition_ids.length === 0) {
    return <span>無</span>;
  }

  return <span>有</span>;
};
